import { render, staticRenderFns } from "./CDRQRecordStatus.vue?vue&type=template&id=0374aedf&scoped=true&"
import script from "./CDRQRecordStatus.vue?vue&type=script&lang=ts&"
export * from "./CDRQRecordStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0374aedf",
  null
  
)

export default component.exports